// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"44902fd1","885":"218f7e1f","977":"b9a42a9d"}[chunkId] + ".chunk.js";
};